<template>
  <div :class="{end:isActivityExpired}">


    <div class="pop-bg" v-if="isZoneAndRoleSelectorShown || isHelpBargainSuccess">
      <!--绑定大区-->
      <div class="pop login-pop" v-show="isZoneAndRoleSelectorShown">
        <div class="close" @click="hideZoneRole"></div>
        <div class="pops">
          <div class="title">
            <div class="line l-line"></div>
            绑定游戏角色<br>领取助力礼包
            <div class="line r-line"></div>
          </div>
          <div class="content">
            <div class="form">
              <div class="list">
                <p class="label">渠道</p>
                <div class="select">
                  <select name="">
                    <option>{{userAgent.iOS?'iOS':'安卓'}}-{{loginState.sessionType=='wc_actoken'?'微信':'QQ'}}</option>
                  </select>
                </div>
              </div>
              <div class="list">
                <p class="label">大区</p>
                <div class="select">
                  <select name="" v-if="zoneInfo" v-model="selectedZoneInfo" @change="changeZone(selectedZoneInfo)">
                    <option disabled value="">请选择大区</option>
                    <option v-for="(zone,index) in zoneInfo" :key="index" :value="zone">{{zone.t}}</option>
                  </select>
                </div>
              </div>
              <div class="list" v-if="selectedRoleName">
                <p class="label">角色</p>
                <div class="select">
                  <select name="">
                    <option>{{selectedRoleName}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="btn comfirm-btn" @click="sendBargainHelperGift"><p>确定</p></div>
        </div>
      </div>



      <div class="pop paysuccess-pop" v-if="isHelpBargainSuccess">
        <div class="close" @click="closeHelpBargainGift"></div>
        <div class="pops">
          <div class="title">
            <div class="line l-line"></div>帮砍成功！<div class="line r-line"></div>
          </div>
          <div class="content">
            <div class="txt">干的漂亮！已经成功帮助好友砍掉<span class="imp">{{helpReducedAmount/10}}</span>点券！</div>
            <p class="txt">送上一份助力礼包~</p>
            <div class="shop-pic">
              <div class="border"></div>
              <img src="../../../ui/20190114/img/success-pic.png" alt="img">
            </div>

          </div>
          <div class="btn game-btn" @click="getUserZoneRole"><p>领取礼包</p></div>
          <p class="txt">请返回游戏邮箱查收</p>
        </div>
      </div>
    </div>



    <div v-show="toastMsg">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <p class="weui-toast__content">{{toastMsg}}</p>
      </div>
    </div>

    <div class="mess-wrap" v-if="!isActivityExpired">
      <div class="user-mess">
        <p class="left"><span></span></p>
        <div class="user-pic-box">
          <img :src="openerAvatar" :alt="openerNickname" />
          <div :class="{'wechat-icon':bargainInfo.origin_type=='wechat','qq-icon':bargainInfo.origin_type=='qq'}"></div>
        </div>
        <p class="rule" @click="showRuleDialog">活动规则</p>
      </div>
    </div>

    <div class="pop-bg"
         v-show="isHelpBargainFailureMsg || isBargainLowestDiscountShown">
      <!--帮砍异常-->
      <div class="pop tips-pop" v-show="isHelpBargainFailureMsg">
        <div class="close" @click="closeHelpBargainFailureMsg"></div>
        <div class="title">
          <div class="line l-line"></div>
          温馨提示
          <div class="line r-line"></div>
        </div>
        <div class="content">
          <div class="txt">{{isHelpBargainFailureMsg}}</div>
        </div>
        <!--<div class="btn comfirm-btn"><p>确定</p></div>-->
      </div>


      <!-- 帮助爆砍一折弹窗 -->
      <div class="pop tips-pop help-cut-pop" v-show="isBargainLowestDiscountShown">
        <div class="close" @click="closeBargainLowestDiscount"></div>
        <div class="title">
          <div class="line l-line"></div>温馨提示<div class="line r-line"></div>
        </div>
        <div class="content">
          <div class="txt">干得漂亮！底价已被砍爆！<br>您已成功帮助好友突破底价，暴击至1折！</div>
        </div>
        <div class="btn comfirm-btn" @click="closeBargainLowestDiscount"><p>确定</p></div>
      </div>

    </div>


    <PopTips :tips-shown.sync="tipsShown" :bargain-info="bargainDetail"></PopTips>

    <div class="shop-box" v-if="isActivityExpired">
      <div class="tips-wrap">
        <img src="../../../ui/20190114/img/expression.png" alt="img">
        <div class="mess-wraps">
          <p class="text">本期活动已结束</p>
          <p class="text">感谢支持</p>
          <p class="text">下期再见哦～</p>
        </div>
      </div>
    </div>
    <div class="shop-box" v-else-if="bargainInfo">
      <div class="title">
        <div class="line l-line"></div>
        <p v-if="bargainInfo.bargain_status=='off' || bargainInfo.bargain_status=='over'">
          砍价已结束
        </p>
        <p v-else>
          砍价进行中
        </p>
        <div class="line r-line"></div>
      </div>

      <p class="success-num" v-if="bargainInfo.now_amt<bargainInfo.least_amt && bargainInfo.bargain_status=='off'" >暴击出现啦！请在订单有效期内支付哦</p>
      <div class="shop-details shop-details1">
        <div class="pic">
          <div class="border"></div>
          <img :src="bargainInfo.product_url" alt="img"/>
          <div :class="{crit:bargainInfo.now_amt<bargainInfo.least_amt}"></div>
        </div>
        <div class="mess">


          <p class="shop-name">{{bargainInfo.product_name}}</p>
<!--          <div class="min-price">-->
<!--            <p>-->
<!--              最低价：<span>{{bargainInfo.least_amt / 10}}</span>-->
<!--            </p>-->
<!--          </div>-->
          <div class="min-price">
            <p>
              当前价：<span style="color:#dedede">{{bargainInfo.now_amt / 10}}</span>
            </p>
          </div>
          <div class="step-box step-box1" v-if="bargainInfo.bargain_status=='on' && tipsShown.isPayButtonShown">
            <p class="mess">倒计时：<span class="red">{{this.countdown.hours}} : {{this.countdown.minutes}} : {{this.countdown.seconds}}</span></p>
          </div>
          <div class="step-box step-box1" v-if="bargainInfo.bargain_status!='on'">
            <p class="mess">砍价用时：<span class="red">{{this.countdown.hours}} : {{this.countdown.minutes}} : {{this.countdown.seconds}}</span></p>
          </div>
<!--          <p class="original-price">原价：{{bargainInfo.origin_amt/10}}</p>-->

<!--          <div class="btn buy-btn now-buy-btn now-buy-btns now-buy-modebtn" :class="{'new-now-buy-btn':bargainInfo.now_amt<bargainInfo.least_amt}" v-if="tipsShown.isPayButtonShown && isBargainOwner && bargainInfo.bargain_status!='over'" @click="showBuyPrompt">-->
<!--          <p class="label">现在购买</p>-->
<!--          </div>-->

<!--          <div class="btn have" v-if="isBargainOwner && bargainInfo.bargain_status=='over'"><p>已拥有</p></div>-->
        </div>
      </div>


      <div class="step-box">
<!--        <p class="mess" v-if="bargainInfo.bargain_status=='on' && tipsShown.isPayButtonShown">-->
<!--          还剩<span class="red">{{this.countdown.hours}} : {{this.countdown.minutes}} : {{this.countdown.seconds}}</span>时间-->
<!--        </p>-->
<!--        <p class="mess" v-else-if="bargainInfo.bargain_status=='off' && tipsShown.isPayButtonShown">-->
<!--          <span v-if="isBargainOwner">-->
<!--            倒计时已结束！等待支付中……-->
<!--          </span>-->
<!--          <span v-else>-->
<!--            倒计时已结束！砍价成功！-->
<!--          </span>-->
<!--        </p>-->
<!--        <p class="mess" v-else-if="bargainInfo.bargain_status=='over'">-->
<!--          倒计时已结束！砍价成功！-->
<!--        </p>-->
        <div class="step-light">
          <p class="label">{{bargainInfo.origin_amt / 10}}点券</p>
          <div class="step-con">
            <div class="step-bbox">
              <p class="baokan">已砍<span class="red">{{(bargainInfo.origin_amt-bargainInfo.now_amt)/10}}</span>点券！剩余<span class="red">{{bargainInfo.now_amt<=bargainInfo.least_amt?0:(bargainInfo.now_amt-bargainInfo.least_amt)/10}}</span>点券</p>
              <div class="step-lines" :class="{'maxline':bargainInfo.now_amt<bargainInfo.least_amt}" :style="{width:(bargainProgress>100?100:bargainProgress)+'%'}"></div>
            </div>
<!--            <p class="num">已砍{{(bargainInfo.origin_amt-bargainInfo.now_amt)/10}}点券</p>-->
            <p class="num-dw">{{(bargainProgress>100?100:bargainProgress)}}%</p>
          </div>
          <p class="r-label">{{(bargainInfo.now_amt<=bargainInfo.least_amt?bargainInfo.now_amt:bargainInfo.least_amt)/10}}点券</p>
        </div>
      </div>

<!--      <p class="success-num">10分钟内砍到底价，额外可得100钻石<br>20分钟内砍到底价，额外可得50钻石</p>-->
      <a href="javascript:void 0;" class="cj-enter" v-if="isBargainOwner" @click="goToLuckDraw">10分钟内砍到底价并支付 享额外抽奖资格</a>
      <!--<div class="step-box">-->
        <!--<p class="mess">已砍<span class="red">-->
          <!--{{(bargainInfo.origin_amt-bargainInfo.now_amt)/10}}</span>点券！只差<span class="red">-->
          <!--{{(bargainInfo.now_amt-bargainInfo.least_amt)/10}}</span>点券！-->
        <!--</p>-->
        <!--<div class="step-line">-->
          <!--<p>{{bargainInfo.origin_amt / 10}}点券</p>-->
          <!--<div class="line-box">-->
            <!--<span class="now-step-line" :style="{width:bargainProgress+'%'}"></span>-->
          <!--</div>-->
          <!--<p>{{bargainInfo.least_amt /10}}点券</p>-->
        <!--</div>-->
      <!--</div>-->


      <p class="opportunity" v-if="isBargainOwner">
        <span v-if="bargainInfo.bargain_status=='on'">
          寻找最强欧气好友，暴击至1折！
        </span>
        <span v-else>
          集合！准备开砍！
        </span>
      </p>
      <p v-else class="opportunity">
        <span v-if="bargainInfo.bargain_status!='over'">
            <span v-if="hasJoinedHelpBargin">
             干的漂亮！成功帮助好友砍掉{{helpReducedAmount/10}}点券
            </span>
            <span v-else>
              寻找最强欧气好友，暴击至1折！
            </span>
        </span>
        <span v-else>
            集合！准备开砍！
        </span>
      </p>
      <!--<p class="opportunity" v-if="isBargainOwner && bargainInfo.bargain_status!='on'">-->
        <!--&lt;!&ndash;每位用户共有<span class="red">10次</span>帮砍机会，单个商品限1次&ndash;&gt;-->
      <!--</p>-->

      <!--<p class="opportunity" v-if="bargainInfo.bargain_status=='on'">-->
        <!--还剩<span class="red">{{this.countdown.hours}} : {{this.countdown.minutes}} : {{this.countdown.seconds}}</span>-->
      <!--</p>-->


      <!--<p class="opportunity" v-else-if="hasJoinedHelpBargin && bargainInfo.bargain_status!='over'">-->
        <!--干的漂亮！砍掉{{helpReducedAmount/10}}点券！-->
        <!--&lt;!&ndash;每位用户共有<span class="red">10次</span>帮砍机会，单个商品限1次&ndash;&gt;-->
      <!--</p>-->


      <div class="dow-btn-wrap flex">
        <div class="btn share-btn l-share-btn" v-if="tipsShown.isPayButtonShown && isBargainOwner && bargainInfo.bargain_status!='over'" @click="showBuyPrompt">
          <p v-if="bargainInfo.bargain_status=='on'">当前价格购买</p>
          <p v-if="bargainInfo.bargain_status=='off'">立即支付</p>
        </div>
        <div class="btn share-btn l-share-btn" v-if="bargainInfo.bargain_status!='on' && isBargainOwner" @click="ownerWantBargain">
          <p>重新发起砍价</p>
        </div>
        <div class="btn share-btn l-share-btn" v-if="bargainInfo.bargain_status=='on' && isBargainOwner && !isInMSDK" @click="share">
          <p>邀请好友帮砍</p>
        </div>

        <div class="btn share-btn l-share-btn" @click="helpOwnerBargain" v-if="bargainInfo.bargain_status=='on' && !isBargainOwner && !helpReducedAmount" >
          <p>立即帮砍</p>
        </div>

        <div class="btn share-btn l-share-btn" @click="helperWantBargain" v-if="(hasJoinedHelpBargin && helpReducedAmount>0) || (bargainInfo.bargain_status!='on' && !isBargainOwner)">
          <p>我也要发起砍价</p>
        </div>
<!--        <div class="btn share-btn l-share-btn" @click="helpOwnerBargain" v-if="(hasJoinedHelpBargin && helpReducedAmount>0) || (bargainInfo.bargain_status!='on' && !isBargainOwner)">-->
<!--          <p>我也要发起砍价test</p>-->
<!--        </div>-->
      </div>

      <a href="javascript:void 0;" class="returnBack" @click="goToIndex">返回首页</a>



      <!-- 游戏外分享 -->
<!--      <div class="dow-btn-wrap">-->
<!--        <div class="btn share-btn l-share-btn" @click="share" v-if="isBargainOwner && bargainInfo.bargain_status=='on' && !isInMSDK">-->
<!--          <p>邀请好友帮砍</p>-->
<!--        </div>-->

<!--        <div class="btn share-btn l-share-btn" @click="ownerWantBargain" v-if="isBargainOwner && bargainInfo.bargain_status!='on' && !isInMSDK">-->
<!--          <p>继续发起砍价</p>-->
<!--        </div>-->

<!--        <div class="btn share-btn l-share-btn" @click="helperWantBargain" v-if="(hasJoinedHelpBargin && helpReducedAmount>0) || (bargainInfo.bargain_status!='on' && !isBargainOwner)">-->
<!--          <p>我也要发起砍价</p>-->
<!--        </div>-->
<!--        <div class="btn share-btn l-share-btn" @click="helpOwnerBargain" v-if="bargainInfo.bargain_status=='on' && !isBargainOwner && !helpReducedAmount" >-->
<!--          <p>立即帮砍</p>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="more-wrap">-->
<!--        <a class="more" v-if="hasJoinedHelpBargin && helpReducedAmount>0" href="javascript:void 0;" @click="goToLuckDraw" >-->
<!--          帮砍成功 快来夺宝 >-->
<!--        </a>-->
<!--        <a class="more" v-if="bargainInfo.bargain_status=='on' && !isBargainOwner && !helpReducedAmount" href="javascript:void 0;" @click="goToIndex" >-->
<!--          我也要发起砍价>>-->
<!--        </a>-->
<!--        <a class="more" v-if="isBargainOwner && bargainInfo.bargain_status=='on' " href="javascript:void 0;" @click="goToIndex">-->
<!--          返回首页>>-->
<!--        </a>-->
<!--      </div>-->
    </div>


    <!-- 游戏内分享 -->
    <div class="shop-box share-block" v-if="isBargainOwner && isInMSDK">
      <div class="title">
        <div class="line l-line"></div>
        邀请好友帮砍
        <div class="line r-line"></div>
      </div>
      <div class="zj-box">
        <ul>
          <li @click="inGameShare('pengy','__mds_client.timeline.bargain')">
            <img src="../../../ui/20190114/img/wechatfind-share.png" alt="img"/>
            <p>分享至朋友圈</p>
          </li>
          <li @click="inGameShare('weixin','__mds_client.wx.bargain')">
            <img src="../../../ui/20190114/img/wechat-share.png" alt="img"/>
            <p>分享至微信</p>
          </li>
          <li @click="inGameShare('qq','__mds_client.qq.bargain')">
            <img src="../../../ui/20190114/img/qq-share.png" alt="img"/>
            <p>分享至QQ</p>
          </li>
          <li @click="inGameShare('qzone','__mds_client.qzone.bargain')">
            <img src="../../../ui/20190114/img/qqzong-share.png" alt="img"/>
            <p>分享至空间</p>
          </li>
        </ul>
      </div>

    </div>



    <div class="shop-box" v-if="bargainJoiner && bargainJoiner.length>0">
      <div class="title">
        <div class="line l-line"></div>
        砍价帮
        <div class="line r-line"></div>
      </div>
      <div class="rank">
        <ul>
          <li v-for="(item,index) in bargainJoiner" :key="item.uin+index">
            <div class="user-head-pic"><img :src="decodeURIComponent(decodeURIComponent(item.nick_img).split('&')[1].split('=')[1] || defaultAvatar)" alt="img"/></div>
            <p class="name">{{decodeURIComponent(decodeURIComponent(item.nick_img).split('&')[0].split('=')[1] || defaultNickname)}}</p>
            <p class="val">{{item.reduced_amt/10}}点券<span class="top" v-show="index==bargainJoinerMaxReducedIndex"></span></p>
          </li>
        </ul>
      </div>
    </div>
    <div class="shop-box" v-if="bargainHelperRecommendList && bargainHelperRecommendList.length>0">
      <div class="title">
        <div class="line l-line"></div>
        热门商品推荐
        <div class="line r-line"></div>
      </div>
      <div class="list-wrap">
        <ul>

          <li v-for="(item,index) in bargainHelperRecommendList" @click="goToIndexFromRecommend(index+1)":key="item.product_id">
            <div class="list">
              <div class="border"></div>
              <img :src="item.product_url" alt="img"/>
              <p class="shop-name">{{item.product_name}}</p>
              <div class="mess-box">
                <p class="original-price">原价：{{item.origin_amt/10}}</p>
                <p class="min-price">最低价：<span>{{item.least_amt/10}}</span></p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="dow-btn-wrap">
        <div class="btn share-btn l-share-btn" @click="goToIndexFromRecommendBtn"><p>查看更多热门商品</p></div>
      </div>
    </div>

    <div class="footer">
      <div class="box">
        <div class="people people3"></div>
        <div class="mess">
<!--          <p><a class="link" @click="goToLuckDraw" href="javascript:void 0;">砍价成功,快来夺宝GO</a></p>-->
          <p>关注【腾讯充值】公众号</p>
          <p>第一时间知道砍价结果</p>
        </div>
        <div v-if="pf!='__mds_client_activity.bargain_wzry'">
          <div class="code" v-if="loginState.sessionType=='wc_actoken'">
            <img src="../../../ui/20190114/img/txcz_wzrybargain_scan.png" alt="img"/></div>
          <div class="code" v-else>
            <img src="../../../ui/20190114/img/qrcode_qq.jpg" alt="img"/>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex"
import PopTips from "./PopTips.vue"
import * as url from "../bargain/utils/url"
import * as configs from "./config"
import Raven from "raven-js"
import localStorage from "../bargain/utils/localStorage"

function init(vm, isHelpBargainSuccessReload) {
  vm.getLoginState()
    .then(() => {
      vm.bargainId = vm.$route.params.bargainId
      vm.bargainOfferId = vm.offerId
      return vm.getBargainById({
        bargainId: vm.bargainId,
        pageSize: vm.pageSize,
        currentPage: vm.currentPage,
        offerId: vm.bargainOfferId
      })
    })
    .then(() => {
      vm.setOnShareHandler({ page: "open", item: vm.bargainInfo, bargainId: vm.bargainId })

      //砍价进度
      vm.bargainProgress = (
        ((vm.bargainInfo.origin_amt - vm.bargainInfo.now_amt) / (vm.bargainInfo.origin_amt - vm.bargainInfo.least_amt)) *
        100
      ).toFixed(2)
      //倒计时
      if (vm.bargainInfo.bargain_status == "on") {
        vm.setCountDownInterval(vm.bargainInfo.bargain_end * 1000 - new Date().getTime())
      } else {
        vm.calCountDown(vm.bargainInfo.bargain_end * 1000 - vm.bargainInfo.bargain_begin * 1000)
      }
      //帮砍人列表
      let maxReducedAmt = 0,
        maxReducedIndex = 0

      vm.bargainJoiner = vm.bargainInfo.join.sort((a, b) => {
        let aHelperTime = new Date(a.join_time.replace(/-/gi, "/")),
          bHelperTime = new Date(b.join_time.replace(/-/gi, "/"))
        return bHelperTime - aHelperTime
      })
      //找到帮砍手气最好的人
      vm.bargainInfo.join.forEach((person, index) => {
        if (maxReducedAmt < person.reduced_amt) {
          maxReducedAmt = person.reduced_amt
          maxReducedIndex = index
        }
      })
      vm.bargainJoinerMaxReducedIndex = maxReducedIndex
      //发起人
      let bargainOpenerInfo = decodeURIComponent(vm.bargainInfo.nick_img).split("&")
      vm.openerNickname = decodeURIComponent(bargainOpenerInfo[0].split("=")[1]) || vm.defaultNickname
      vm.openerAvatar = decodeURIComponent(bargainOpenerInfo[1].split("=")[1]) || vm.defaultAvatar
      vm.isBargainOwner = vm.bargainInfo.origin == vm.bargainInfo.user_comm_id
      vm.hasJoinedHelpBargin = vm.bargainInfo.join.some(joiner => {
        if (joiner.uin == vm.bargainInfo.user_comm_id && !vm.isBargainOwner) {
          vm.helpReducedAmount = joiner.reduced_amt
          return true
        }
      })

      if (!isHelpBargainSuccessReload) {
        if (vm.bargainInfo.bargain_status == "on") {
          if (vm.isBargainOwner) {
            vm.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.OPENER_BARGAIN_PROGRESSING,
              resultInfo: `bargain_id=${vm.bargainId}`
            })
          } else {
            vm.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.HELPER_BARGAIN_PROGRESSING,
              resultInfo: `bargain_id=${vm.bargainId}`
            })
          }
        } else {
          if (vm.isBargainOwner) {
            vm.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.OPENER_BARGAIN_END,
              resultInfo: `bargain_id=${vm.bargainId}`
            })
          } else {
            vm.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.HELPER_BARGAIN_END,
              resultInfo: `bargain_id=${vm.bargainId}`
            })
          }
        }
      }

      //热门商品查推荐
      vm.getBargainHelperRecommend().then(res => {
        if (res.recomm_info) {
          vm.bargainHelperRecommendList = configs.PRODUCTS.filter(item => {
            return (
              item.product_id == res.recomm_info.product1 ||
              item.product_id == res.recomm_info.product2 ||
              item.product_id == res.recomm_info.product3
            )
          })
        }
      })
    })
    .catch(res => {
      if (res && res.ret == 1414) {
        vm.isActivityExpired = true
      } else {
        Raven.captureException(new Error("get-bargain-detail-error"), {
          tags: { type: "get-bargain-detail-error" },
          extra: {
            res,
            getters: vm.$store.getters,
            rootState: vm.$store.state
          }
        })
      }
      vm.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.BARGAIN_DETAIL_ERROR,
        resultInfo: JSON.stringify({ res, loginState: vm.loginState })
      })
    })
}

export default {
  name: "Open",
  components: {
    PopTips
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      bargainProgress: 0,
      tipsShown: {
        isBuyPromptShown: false,
        isRuleShown: false,
        isWechatShareGuideShown: false,
        isPaySuccess: false,
        isPayButtonShown: true,
        isPayErrorMsg: "",
        isPlaceOrderErrorMsg: ""
      },
      toastMsg: "",
      bargainId: "",
      bargainOfferId: "",
      bargainDetail: {
        price: 0,
        name: "潮流闲人"
      },
      countdown: 0,
      openerNickname: "腾讯充值用户",
      openerAvatar: require("../../../ui/20180706kanjia_p/ossweb-img/u.jpg"),
      defaultAvatar: require("../../../ui/20180706kanjia_p/ossweb-img/u.jpg"),
      defaultNickname: "腾讯充值用户",
      isBargainOwner: false,
      bargainJoiner: "",
      bargainJoinerMaxReducedIndex: 0,
      helpReducedAmount: 0,
      isHelpBargainSuccess: false,
      isHelpBargainFailureMsg: "",
      isHelpBargainProcess: false,
      hasJoinedHelpBargin: false,
      bargainHelperRecommendList: "",
      isActivityExpired: false,
      isBargainLowestDiscountShown: false,
      isZoneAndRoleSelectorShown: false,
      zoneInfo: "",
      selectedZoneInfo: "",
      selectedRoleName: "",
      hasNoRoles: true
    }
  },
  mounted() {},
  computed: {
    ...mapState(["isInMSDK", "userAgent"]),
    ...mapGetters(["bargainInfo", "loginState", "offerId", "pf"])
  },
  beforeRouteEnter: (to, from, next) => {
    next(init)
  },
  methods: {
    ...mapActions([
      "reportUserAction",
      "getLoginState",
      "getBargainById",
      "showMqqShareMenu",
      "helpBargain",
      "placeOrder",
      "pay",
      "getBargainHelperRecommend",
      "msdkShareTo",
      "setOnShareHandler",
      "sendQualification",
      "getZoneInfo",
      "getUserRecommendZone",
      "getRoleInfo",
      "setSelectedZone",
      "midasPay"
    ]),
    calCountDown(timediff) {
      let seconds = Math.floor((timediff / 1000) % 60)
      let minutes = Math.floor((timediff / 1000 / 60) % 60)
      let hours = Math.floor((timediff / (1000 * 60 * 60)) % 24)
      this.countdown = {
        seconds: seconds < 10 ? "0" + (seconds <= 0 ? "0" : seconds) : seconds,
        minutes: minutes < 10 ? "0" + (minutes <= 0 ? "0" : minutes) : minutes,
        hours: hours < 10 ? "0" + (hours <= 0 ? "0" : hours) : hours
      }
      return timediff
    },
    setCountDownInterval(timediff) {
      let t = timediff
      this.calCountDown(timediff)
      let intervalTimer = setInterval(() => {
        // 得到剩余时间
        t = t - 1000
        let remainTime = this.calCountDown(t)

        if (remainTime <= 0) {
          clearInterval(intervalTimer)
        }
      }, 1000)
    },
    showRuleDialog() {
      this.tipsShown.isRuleShown = true
      this.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.RULE
      })
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.SHOW_RULE
      })
    },
    showBuyPrompt() {
      let params = {
        extendParams: {
          zoneid: url.getParam("zoneid", decodeURIComponent(this.bargainInfo.cgi_info)),
          is_filter_goods: 1,
          change_openid: 1,
          change_wx_openid: this.loginState.sessionType == "wc_actoken" && this.userAgent.weixin ? 1 : 0
        },
        gameId: url.getParam("gameid", decodeURIComponent(this.bargainInfo.cgi_info))
      }

      this.getZoneInfo()
        .then(zones => {
          let os = "",
            account = "",
            area,
            cacheZoneInfo,
            defaultSelectedZoneId,
            cgiArea = params.gameId.split("___")[0]
          if (this.userAgent.weixin) {
            account = "weixin"
          } else if (this.userAgent.QQ) {
            account = "qq"
          }

          if (this.userAgent.iOS) {
            os = "ios"
          } else if (this.userAgent.android) {
            os = "android"
          }

          if (!this.userAgent.msdk) {
            if (account == "weixin" && os == "ios") {
              area = "4"
            } else if (account == "weixin" && os == "android") {
              area = "3"
            } else if (account == "qq" && os == "ios") {
              area = "2"
            } else if (account == "qq" && os == "android") {
              area = "1"
            }
          } else {
            area = url.getParam("area")
          }

          if (!this.isInMSDK) {
            cacheZoneInfo = localStorage.get(`wzry_bargain_${this.offerId}_${this.loginState.openid}`, true)
            if (cacheZoneInfo) {
              defaultSelectedZoneId = cacheZoneInfo.v
            } else {
              defaultSelectedZoneId = ""
            }
          } else {
            defaultSelectedZoneId = url.getParam("partition")
          }

          if (area != cgiArea) {
            //用户下单时候的系统和发起砍价的不一致
            this.tipsShown.isPlaceOrderErrorMsg = "当前平台与砍价发起时不同，无法正常支付发货。请切换平台重试。"
            this.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.USER_OS_NOT_MATCH,
              resultInfo: JSON.stringify({
                bargainId: this.bargainId,
                bargainInfo: this.bargainInfo
              })
            })
          } else {
            this.placeOrder(params)
              .then(res => {
                this.bargainDetail = {
                  price: this.bargainInfo.now_amt / 10,
                  name: this.bargainInfo.product_name,
                  logo: this.bargainInfo.product_url,
                  token: res.token,
                  bargainId: this.bargainId,
                  offerId: this.bargainOfferId,
                  bargainStatus: this.bargainInfo.bargain_status,
                  mid: res.mid,
                  stopBargainPromptMsg: "现在购买好友将无法继续帮砍哦！"
                }

                let userLogingameid = `${[area, "", "", defaultSelectedZoneId].join("_")}`
                if (userLogingameid != params.gameId) {
                  //用户发起砍价的大区信息和当前登陆的不一致
                  this.reportUserAction({
                    iformat: configs.REPORT.PAGEVIEW.USER_PARTITION_NOT_MATCH,
                    resultInfo: JSON.stringify({
                      bargainId: this.bargainId,
                      bargainInfo: this.bargainInfo
                    })
                  })
                  let bargainZone = zones.filter(zone => {
                    return zone.status == 1 && zone.v == params.extendParams.zoneid
                  })[0]
                  this.bargainDetail.zoneConfirmMsg = `道具即将发到${bargainZone.c == 2 || bargainZone.c == 4 ? "iOS" : "安卓"}${
                    bargainZone.t
                  }，您确定吗？`
                  this.tipsShown.isBuyPromptShown = true
                }
                if (res.filter_info && res.filter_info[this.bargainInfo.product_id]) {
                  if (res.filter_info[this.bargainInfo.product_id].indexOf("2310") > -1) {
                    this.reportUserAction({
                      iformat: configs.REPORT.PAGEVIEW.USER_HAS_ITEM,
                      resultInfo: JSON.stringify({ res, loginState: this.loginState })
                    })
                    //用户已拥有该物品
                    this.tipsShown.isPlaceOrderErrorMsg = "您已拥有该物品！"
                  } else if (res.filter_info[this.bargainInfo.product_id].indexOf("2312") > -1) {
                    //用户没有该星元皮肤依赖的前置皮肤
                    this.bargainDetail.filter_info = "2312"
                    this.bargainDetail.buyPromptMsg = "注意：您现在还未拥有该皮肤，先拥有皮肤后才可以体验星元皮肤哦"
                    this.tipsShown.isBuyPromptShown = true
                  } else if (res.filter_info[this.bargainInfo.product_id].indexOf("2311") > -1) {
                    //用户没有该英雄
                    this.bargainDetail.buyPromptMsg = "注意：您现在还未拥有该英雄，先拥有英雄后才可以体验皮肤哦"
                    // this.tipsShown.isPlaceOrderErrorMsg = "您还没有该英雄！"
                    this.bargainDetail.filter_info = "2311"
                    this.tipsShown.isBuyPromptShown = true
                  }
                }

                if (!this.tipsShown.isBuyPromptShown && !this.tipsShown.isPlaceOrderErrorMsg) {
                  // this.tipsShown.isBuyPromptShown = true
                  this.startPay()
                }
              })
              .catch(res => {
                this.tipsShown.isPlaceOrderErrorMsg = res.msg || `系统繁忙，请稍候再试！(${res.ret})`
              })
          }
        })
        .catch(res => {
          this.tipsShown.isPlaceOrderErrorMsg = (res && res.msg) || `系统繁忙，请稍候再试！(${res && res.ret})`
        })

      if (this.bargainInfo.bargain_status == "on") {
        this.reportUserAction({
          iformat: configs.REPORT.CLICK.BARGAIN_DETAIL_ONGOING_BUY,
          resultInfo: `bargain_id=${this.bargainId}`
        })
      } else if (this.bargainInfo.bargain_status == "off") {
        this.reportUserAction({
          iformat: configs.REPORT.CLICK.BARGAIN_DETAIL_END_BUY,
          resultInfo: `bargain_id=${this.bargainId}`
        })
      }
    },
    share() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.BARGAIN_DETAIL_INVITE_FRIENDS,
        resultInfo: `bargain_id=${this.bargainId}`
      })
      if (this.userAgent.weixin) {
        this.tipsShown.isWechatShareGuideShown = true
      } else if (this.userAgent.QQ) {
        this.showMqqShareMenu()
      }
    },
    inGameShare(selected, pf) {
      this.msdkShareTo({
        selected,
        bargainId: this.bargainId,
        pf,
        offerId: this.bargainOfferId,
        item: this.bargainInfo
      })
    },
    helpOwnerBargain() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.HELP_BARGAIN,
        resultInfo: `bargain_id=${this.bargainId}`
      })
      if (this.isHelpBargainProcess) {
        return
      }
      // this.getUserZoneRole()
      this.isHelpBargainProcess = true
      this.helpBargain({
        productId: this.bargainInfo.product_id,
        bargainId: this.bargainId,
        offerId: this.bargainOfferId
      })
        .then(info => {
          // this.bargainCurrentPrice = info.now_amt
          // this.bargainProgress = (((info.origin_amt - info.now_amt) / (info.origin_amt - this.bargainLeastPrice)) * 100).toFixed(2)
          this.isHelpBargainSuccess = true
          this.isHelpBargainProcess = false
          // this.hasJoinedHelpBargin = true
          // this.sendQualification(configs.SEND_QUALIFICATION_GROUPID.HELP)
          this.helpReducedAmount = info.reduce_amt
          this.isHelpBargainFailureMsg = ""
          init(this, true)
          // this.toastMsg = "帮砍成功！"
          this.reportUserAction({
            iformat: configs.REPORT.PAGEVIEW.HELP_BARGAIN_SUCCESS,
            resultInfo: `bargain_id=${this.bargainId}`
          })

          if (info.now_amt < this.bargainInfo.least_amt) {
            //已经砍到暴击底价
            this.isBargainLowestDiscountShown = true
            this.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.HELPER_BAOJI_POPUP,
              resultInfo: `bargain_id=${this.bargainId}`
            })
          }

          // setTimeout(() => {
          //   this.toastMsg = ""
          // }, 1500)
          // this.reportUserAction({
          //   iformat: config.REPORT.PAGEVIEW.BARGAIN_HELPER_SUCCESS
          // })
        })
        .catch(res => {
          if (res && res.err_code && res.err_code.indexOf("1132-81009") > -1) {
            this.isHelpBargainFailureMsg = `每人可帮好友砍价${res.limit_times}次，你已超过次数，这是真爱没错了！`

            this.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.EXCEED_HELP_BARGAIN_MAXMUM,
              resultInfo: `bargain_id=${this.bargainId}`
            })
          } else {
            this.isHelpBargainFailureMsg = `${res.msg || "系统繁忙,请稍候再试"}(${res.ret})`
            this.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.HELP_BARGAIN_FAILURE,
              resultInfo: `bargain_id=${this.bargainId}`
            })
          }
          this.isHelpBargainProcess = false
        })
    },
    closeHelpBargainFailureMsg() {
      this.isHelpBargainFailureMsg = ""
    },
    goToIndex() {
      this.$router.push("/")
    },
    goToLuckDraw() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.BARGAIN_STARTER_LUCK_DRAW,
        resultInfo: `bargain_id=${this.bargainId}`
      })
      let new_url = url.delParam(["pf"], location.href)
      let queryStr = new_url.split("?")[1] || ""
      let partition = ""
      if (queryStr.indexOf("partition=") > -1) {
        partition = ""
      } else if (url.getParam("zoneid", decodeURIComponent(this.bargainInfo.cgi_info))) {
        partition = `&partition=${url.getParam("zoneid", decodeURIComponent(this.bargainInfo.cgi_info))}`
      }
      location.href = `${configs.LUCKY_DRAW_URL}${partition}&${queryStr}`
    },
    ownerWantBargain() {
      // this.reportUserAction({
      //   iformat: configs.REPORT.CLICK.HELPER_WANT_BARGAIN
      // })
      this.$router.push("/")
    },
    helperWantBargain() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.HELPER_WANT_BARGAIN,
        resultInfo: `bargain_id=${this.bargainId}`
      })
      this.$router.push("/")
    },
    goToIndexFromRecommend(index) {
      this.reportUserAction({
        iformat: `${configs.REPORT.CLICK.BARGAIN_HELPER_RECOMMEND}${index}`,
        resultInfo: `bargain_id=${this.bargainId}`
      })
      this.$router.push("/")
    },
    goToIndexFromRecommendBtn() {
      this.reportUserAction({
        iformat: `${configs.REPORT.CLICK.RECOMMEND_BACK_INDEX}`,
        resultInfo: `bargain_id=${this.bargainId}`
      })
      this.$router.push("/")
    },
    closeBargainLowestDiscount() {
      this.isBargainLowestDiscountShown = false
    },
    showZoneRole() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.CHOOSE_ZONE,
        resultInfo: `bargain_id=${this.bargainId}`
      })
      this.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.CHANGE_ZONE,
        resultInfo: `bargain_id=${this.bargainId}`
      })
      return this.getZoneInfo().then(zones => {
        let os = "",
          account = ""
        if (this.userAgent.weixin) {
          account = "weixin"
        } else if (this.userAgent.QQ) {
          account = "qq"
        }

        if (this.userAgent.iOS) {
          os = "ios"
        } else if (this.userAgent.android) {
          os = "android"
        }
        this.zoneInfo = zones.filter(zone => {
          let result
          if (zone.status == 1 && (zone.sk && zone.sk == os) && (zone.ck && zone.ck == account) && zone.c != 6 && zone.c != 7) {
            //手游
            result = true
          }
          return result
        })
        this.isZoneAndRoleSelectorShown = true
      })
    },
    hideZoneRole() {
      this.isZoneAndRoleSelectorShown = false
    },
    getUserZoneRole() {
      this.isHelpBargainSuccess = false
      this.isZoneAndRoleSelectorShown = true
      if (!this.isInMSDK) {
        //游戏外
        let defaultSelectedZone = localStorage.get(`wzry_bargain_${this.offerId}_${this.loginState.openid}`, true)
        if (!defaultSelectedZone) {
          //本地缓存没有用户选过的大区
          Promise.all([this.showZoneRole(), this.getUserRecommendZone()])
            .then(results => {
              if (results[1].recomm_info && results[1].recomm_info.part) {
                this.selectedZoneInfo = this.zoneInfo.filter(zone => {
                  return zone.v == results[1].recomm_info.part
                })[0]
                this.changeZone(this.selectedZoneInfo)
              } else {
                this.hasNoRoles = true
              }
            })
            .catch(res => {
              this.hasNoRoles = true
              Raven.captureException(new Error("get-user-role-error"), {
                tags: { type: "get-user-role-error" },
                extra: {
                  res,
                  getters: this.$store.getters,
                  rootState: this.$store.state
                }
              })
              this.reportUserAction({
                iformat: configs.REPORT.CLICK.BARGAIN_HELPER_ZONE_ROLE_ERROR,
                resultInfo: `bargain_id=${this.bargainId}`
              })
            })
        } else {
          this.showZoneRole()
          this.setSelectedZone(defaultSelectedZone)
          this.selectedZoneInfo = defaultSelectedZone
          this.changeZone(defaultSelectedZone)
        }
      } else {
        this.getZoneInfo().then(zones => {
          let currentPartition = url.getParam("partition")
          this.selectedZoneInfo = zones.filter(zone => {
            return zone.v == currentPartition
          })[0]

          this.getRoleInfo({ platformId: this.selectedZoneInfo.s, area: this.selectedZoneInfo.c, zoneid: this.selectedZoneInfo.v }).then(
            res => {
              let roles = decodeURIComponent(res.role_list).split(";"),
                rolesArr = []
              roles.forEach(item => {
                if (item) {
                  let role = item.split(":")
                  if (role[0] && role[1]) {
                    rolesArr.push({ name: role[1], id: role[0] })
                  }
                }
              })
              if (rolesArr.length > 0) {
                this.selectedRoleName = rolesArr[0].name
              }
            }
          )
        })
      }
    },
    changeZone(zone) {
      this.hasNoRoles = true
      this.selectedRoleName = ""
      this.getRoleInfo({ platformId: zone.s, area: zone.c, zoneid: zone.v })
        .then(res => {
          let roles = decodeURIComponent(res.role_list).split(";"),
            rolesArr = []
          roles.forEach(item => {
            if (item) {
              let role = item.split(":")
              if (role[0] && role[1]) {
                rolesArr.push({ name: role[1], id: role[0] })
              }
            }
          })
          if (rolesArr.length == 0) {
            this.hasNoRoles = true
            this.toastMsg = "你在此区无游戏角色"
            setTimeout(() => {
              this.toastMsg = null
            }, 2000)
            return
          } else {
            this.hasNoRoles = false
            this.selectedRoleName = rolesArr[0].name
          }
        })
        .catch(res => {
          if (res.ret == 1220) {
            this.toastMsg = "你在此区无游戏角色"
          } else {
            this.toastMsg = res.msg || "查询角色系统繁忙，请稍候再试！"
          }
          setTimeout(() => {
            this.toastMsg = null
          }, 2000)
          this.hasNoRoles = true
          this.selectedRoleName = ""
        })
    },
    sendBargainHelperGift() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.HELP_BARGAIN_SUCCESS_RECEIVE_GIFT,
        resultInfo: `bargain_id=${this.bargainId}`
      })
      if (!this.hasNoRoles && this.selectedZoneInfo && this.selectedZoneInfo.v) {
        this.setSelectedZone(this.selectedZoneInfo)
        let gameid = `${[this.selectedZoneInfo.c, "", "", this.selectedZoneInfo.v].join("_")}`
        this.sendQualification({ group_id: configs.SEND_QUALIFICATION_GROUPID.HELP, gameid })
          .then(() => {
            this.reportUserAction({
              iformat: configs.REPORT.CLICK.HELP_BARGAIN_SUCCESS_RECEIVE_GIFT_SUCCESS,
              resultInfo: `bargain_id=${this.bargainId}`
            })
            this.toastMsg = "礼包领取成功"
            this.hideZoneRole()
          })
          .catch(res => {
            if (res && res.ret) {
              this.reportUserAction({
                iformat: configs.REPORT.CLICK.HELP_BARGAIN_SUCCESS_RECEIVE_GIFT_ERROR,
                resultInfo: `bargain_id=${this.bargainId}`
              })
              this.toastMsg = res.msg || "系统繁忙，请稍后再试"
            }
          })
          .then(() => {
            setTimeout(() => {
              this.toastMsg = null
            }, 2000)
          })
      } else {
        this.toastMsg = "请选择有角色的大区"
        setTimeout(() => {
          this.toastMsg = null
        }, 2000)
      }
    },
    startPay() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.OWNER_PAY_OTHER_WAY,
        reusltInfo: `bargain_id=${this.bargainId}`
      })

      this["midasPay"]({
        bargainId: this.bargainDetail.bargainId,
        token: this.bargainDetail.token,
        offerId: this.bargainDetail.offerId,
        billNo: this.bargainDetail.billNo,
        mid: this.bargainDetail.mid,
        realPrice: this.bargainDetail.price * 10
      }).then(() => {
        this.tipsShown.isPaySuccess = true
        this.tipsShown.isPayButtonShown = false
        this.tipsShown.isBuyPromptShown = false
        this.reportUserAction({
          iformat: configs.REPORT.PAGEVIEW.BUY_SUCCESS,
          reusltInfo: `bargain_id=${this.bargainId}`
        })
      })
    },
    closeHelpBargainGift() {
      this.isHelpBargainSuccess = false
    }
  }
}
</script>

<style scoped>
</style>
